<template>
  <div class="overflow-hidden bg-white rounded-md shadow">
    <ul class="divide-y divide-gray-200">
      <li v-for="menu in menus" :key="menu.id">
        <router-link
          :to="{ name: 'Dishes', params: { idmenu: menu.id } }"
          class="block transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
        >
          <div class="flex items-center px-4 py-4 sm:px-6">
            <div class="flex items-center flex-1 min-w-0">
              <div class="flex-shrink-0">
                <svg
                  v-if="menu.url == null && showicon"
                  class="w-10 h-10"
                  height="512"
                  viewBox="0 0 128 128"
                  width="512"
                  xmlns="http://www.w3.org/2000/svg"
                  data-name="Layer 2"
                >
                  <path
                    d="M20.333 14.667h87.333V126.25H20.333z"
                    fill="#efebe9"
                  />
                  <path
                    d="M58.965 39.122a8.893 8.893 0 00-8.429-8.2A8.769 8.769 0 0041.5 38.9l-1.13 12.788c-.386 4.352 1.481 7.781 4.748 9.018L43.442 89.82A6.8 6.8 0 1057 89.839l-1.672-29.133c3.267-1.237 5.133-4.666 4.748-9.018zM87.631 51.688l-.386-4.357V32.667a1.75 1.75 0 00-3.5 0v12.991h-4.218V32.667a1.75 1.75 0 00-3.5 0v12.991H71.81V32.667a1.75 1.75 0 00-3.5 0v14.664l-.386 4.357c-.385 4.352 1.482 7.781 4.748 9.018L71 89.819a6.8 6.8 0 1013.562.02l-1.679-29.133c3.265-1.237 5.133-4.666 4.748-9.018z"
                    fill="#dfccc9"
                  />
                  <path d="M29.875 105h68.25v12.25h-68.25z" fill="#fd7eb8" />
                  <path d="M20.333 14.667L94.25 1.75v12.917z" fill="#a1887f" />
                  <g fill="#271800">
                    <path
                      d="M20.333 78.418a1.749 1.749 0 001.75-1.75v-7.5a1.75 1.75 0 00-3.5 0v7.5a1.75 1.75 0 001.75 1.75z"
                    />
                    <path
                      d="M107.667 12.917H96V1.75A1.75 1.75 0 0093.949.026L20.032 12.942a1.784 1.784 0 00-1.449 1.725v40.166a1.75 1.75 0 003.5 0V16.417h83.834V124.5H22.083V91a1.75 1.75 0 00-3.5 0v35.25a1.751 1.751 0 001.75 1.75h87.334a1.75 1.75 0 001.75-1.75V14.667a1.749 1.749 0 00-1.75-1.75zm-67.152 0L92.5 3.833v9.084z"
                    />
                    <path
                      d="M44.987 39.21a5.272 5.272 0 015.426-4.789 1.75 1.75 0 00.123-3.5A8.769 8.769 0 0041.5 38.9l-1.13 12.788c-.386 4.352 1.481 7.781 4.748 9.018L43.442 89.82A6.8 6.8 0 1057 89.839l-1.672-29.133c3.267-1.237 5.133-4.666 4.748-9.018l-1.111-12.566a1.75 1.75 0 10-3.486.308L56.59 52c.1 1.194.177 5.129-3.348 5.653a1.75 1.75 0 00-1.49 1.832l1.759 30.575a3.262 3.262 0 01-.878 2.476 3.374 3.374 0 01-4.82 0 3.275 3.275 0 01-.877-2.5l1.758-30.56a1.75 1.75 0 00-1.49-1.832c-3.525-.519-3.454-4.454-3.348-5.644zM70.06 30.917a1.75 1.75 0 00-1.75 1.75v14.664l-.386 4.357c-.385 4.352 1.482 7.781 4.748 9.018L71 89.819a6.8 6.8 0 1013.562.02l-1.679-29.133c3.265-1.237 5.133-4.666 4.748-9.018l-.386-4.357V32.667a1.75 1.75 0 00-3.5 0v12.991h-4.218V32.667a1.75 1.75 0 00-3.5 0v12.991H71.81V32.667a1.751 1.751 0 00-1.75-1.75zM80.8 57.649a1.75 1.75 0 00-1.49 1.832l1.758 30.58a3.259 3.259 0 01-.878 2.474 3.374 3.374 0 01-4.82 0 3.28 3.28 0 01-.877-2.5l1.758-30.56a1.75 1.75 0 00-1.49-1.832c-3.527-.517-3.456-4.453-3.351-5.643l.251-2.838h12.233L84.145 52c.105 1.19.175 5.125-3.345 5.649zM28.125 105v12.25a1.751 1.751 0 001.75 1.75h68.25a1.75 1.75 0 001.75-1.75V105a1.75 1.75 0 00-1.75-1.75h-68.25a1.751 1.751 0 00-1.75 1.75zm3.5 1.75h64.75v8.75h-64.75z"
                    />
                  </g>
                </svg>
                <img
                  v-else-if="showicon"
                  class="w-10 h-10"
                  :src="getCategoryIcon(menu.url)"
                />
              </div>
              <div class="flex-1 min-w-0 px-4 md:grid md:grid-cols-2 md:gap-4">
                <div>
                  <h2
                    class="text-sm font-medium leading-5"
                    :class="'text-' + $store.state.color.primary"
                  >
                    {{ get(menu.translations, $store.state.locale, "name") }}

                    <span v-if="menu.menuDate" class="text-sm text-black">
                      - {{ menu.menuDate }}
                    </span>

                    <span v-if="menu.booking" class="text-xs text-black">
                      <br />
                      {{ menu.booking }}
                    </span>
                  </h2>
                </div>
              </div>
            </div>
            <div>
              <svg
                class="w-5 h-5 text-gray-400"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </router-link>
      </li>
    </ul>
    <ModalSwitchMenuLocation
      v-show="modal.show"
      :icon="modal.icon"
      :title="modal.title"
      :description="modal.description"
      :showButtonRoomService="modal.showButtonRoomService"
      :showButtonHotel="modal.showButtonHotel"
      :showButtonRestaurant="modal.showButtonRestaurant"
    ></ModalSwitchMenuLocation>
  </div>
</template>

<script>
import Translations from "../../../apis/Translations";
import IconService from "../../../apis/IconService";
//import isWithinRange from 'date-fns/is_within_range'
//import format from "date-fns/format"
//import distanceInWords from "date-fns/distance_in_words"
//import subDays from "date-fns/sub_days"
//import {formatDistance, subDays} from 'date-fns/esm'

import isWithinInterval from "date-fns/isWithinInterval";
import addDays from "date-fns/addDays";
import { parse, addHours, format } from "date-fns";
import ModalSwitchMenuLocation from "./../../../components/ModalSwitchMenuLocation";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      //showMenuHotel: this.calculateShowMenuHotel(),
      showPopUp:
        (this.$store.state.location.menuRestaurantCount > 0 &&
          this.$store.state.location.menuHotelCount > 0) ||
        (this.$store.state.location.menuRestaurantCount == 0 &&
          this.$store.state.location.menuHotelCount -
            this.$store.state.location.menuRoomServiceCount >
            0 &&
          this.$store.state.location.menuRoomServiceCount > 0)
          ? true
          : false,

      modal: {
        type: "",
        show: false,
        title: "",
        description: "",
        icon: "",
        showButtonRoomService: false,
        showButtonHotel: false,
        showButtonRestaurant: false,
      },
    };
  },
  components: {
    ModalSwitchMenuLocation,
  },
  methods: {
    ...mapActions(["setUserShowMwnu"]),

    getBookingString(menu) {
      //Prenotabile dalle 18:30 31/08 alle 19:30 01/09

      return menu.id + "bla";
    },

    /*
    calculateShowMenuHotel() {
      if (this.$store.state.userShowMenuHotel == -1) {
        if (
          this.$store.state.location.menuRestaurantCount > 0 &&
          this.$store.state.location.menuHotelCount > 0
        ) {
          return -2;
        } else if (this.$store.state.location.menuRestaurantCount > 0) {
          return 0;
        }
        return 1;
      } else {
        this.$store.state.userShowMenuHotel;
      }
    },
    */

    get: function(translations, locale, prop) {
      return Translations.get(translations, locale, prop);
    },

    getCategoryIcon: function(url) {
      return IconService.getIconCat(url);
    },
  },
  mounted() {
    if (this.$store.state.userShowMenuHotel == -1 && this.showPopUp) {
      //this.modal.title = "Di quale struttura sei ospite?";
      this.modal.title = "Quale menu vuoi consultare?";
      this.modal.description = "Scegli una opzione";
      this.modal.icon = "party";
      this.modal.show = true;

      this.modal.showButtonHotel =
        this.$store.state.location.menuHotelCount -
          this.$store.state.location.menuRoomServiceCount >
        0
          ? true
          : false;
      this.modal.showButtonRoomService =
        this.$store.state.location.menuRoomServiceCount > 0 ? true : false;
      this.modal.showButtonRestaurant =
        this.$store.state.location.menuRestaurantCount > 0 ? true : false;

      this.$root.$on("eventhotel", () => {
        //this.showMenuHotel = 1;
        this.modal.show = false;
        this.$store.dispatch("setUserShowMwnu", 1);
      });

      this.$root.$on("eventrestaurant", () => {
        //this.showMenuHotel = 0;
        this.modal.show = false;
        this.$store.dispatch("setUserShowMwnu", 0);
      });

      this.$root.$on("eventroomservice", () => {
        //this.showMenuHotel = 0;
        this.modal.show = false;
        this.$store.dispatch("setUserShowMwnu", 2);
      });
    }

    //????????????????????????????????????????????????????
    if (!this.showPopUp) {
      if (this.$store.state.location.menuRestaurantCount > 0) {
        this.$store.dispatch("setUserShowMwnu", 0);
      } else if (
        this.$store.state.location.menuRoomServiceCount -
          this.$store.state.location.menuHotelCount ==
        0
      ) {
        this.$store.dispatch("setUserShowMwnu", 2);
      } else {
        this.$store.dispatch("setUserShowMwnu", 1);
      }

      // this.$store.state.location.menuRoomServiceCount
      // this.$store.state.location.menuHotelCount
    }
  },
  computed: {
    showicon() {
      return this.$store.state.location.extra.showicon;
    },
    menus() {
      return this.$store.state.location.menus.filter((item) => {
        console.log(this.$store.state.userShowMenuHotel);

        if (this.$store.state.userShowMenuHotel == -1) {
          return false;
        }

        if (this.$store.state.userShowMenuHotel == 0 && item.is_hotel == 1) {
          return false;
        }

        if (
          this.$store.state.userShowMenuHotel == 1 &&
          (item.is_hotel == 0 || item.is_room_service == 1)
        ) {
          return false;
        }

        if (
          this.$store.state.userShowMenuHotel == 2 &&
          (item.is_hotel == 0 || item.is_room_service == 0)
        ) {
          return false;
        }

        /*
        if (this.$store.state.userShowMenuHotel != item.is_hotel) {
          return false;
        }
        */

        if (item.schedule == null) {
          return true;
        } else {
          let scheduleType = item.schedule.scheduleType;
          let startTime = item.schedule.startTime;
          let endTime = item.schedule.endTime;
          let now = new Date();
          let startDateTime = null;
          let endDateTime = null;
          let show = false;

          if (this.$store.state.userShowMenuHotel == 1) {
            let startBookingDate = new Date();
            let endBookingDate = new Date();
            let reservationType = item.schedule.reservationType;

            if (startTime > endTime) {
              endBookingDate = addDays(endBookingDate, 1);

              if (reservationType === 0 && now.getHours() < endTime) {
                startBookingDate = addDays(startBookingDate, -1);
                endBookingDate = addDays(endBookingDate, -1);
              }

              item.booking =
                "Prenotabile dalle ore " +
                startTime +
                " del " +
                format(startBookingDate, "dd/MM") +
                " alle ore " +
                endTime +
                " del " +
                format(endBookingDate, "dd/MM");
            } else {
              item.booking =
                "Prenotabile dalle ore " +
                startTime +
                " alle ore " +
                endTime +
                " del " +
                format(startBookingDate, "dd/MM");
            }

            let now2 = new Date();
            if (
              reservationType === 0 &&
              (startTime < endTime ||
                (startTime > endTime &&
                  now2.getHours() >= startTime &&
                  now2.getHours() < 24))
            ) {
              now2 = addDays(now2, 1);
            }
            item.menuDate = "del " + format(now2, "dd/MM");
          }

          /*
            if(scheduleType == 0){
              startDateTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), startTime);
              endDateTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), endTime);

              if(startTime >= endTime){
                endDateTime = addDays(endDateTime, 1);
              }

              show = isWithinInterval( now, {start: startDateTime, end: endDateTime} )
            }
            */
          if (scheduleType == 0) {
            if (startTime < endTime) {
              if (now.getHours() >= startTime && now.getHours() < endTime) {
                show = true;
              }
            } else {
              if (
                (now.getHours() >= startTime && now.getHours() < 24) ||
                (now.getHours() >= 0 && now.getHours() < endTime)
              ) {
                show = true;
              }
            }
          }

          if (scheduleType == 2) {
            for (
              let i = 0;
              i < item.schedule.selectedDates.length && !show;
              i++
            ) {
              let check = parse(
                item.schedule.selectedDates[i],
                "dd/MM/yyyy",
                new Date()
              );
              startDateTime = addHours(check, startTime);
              endDateTime = addHours(check, endTime);

              if (startTime >= endTime) {
                endDateTime = addDays(endDateTime, 1);
              }

              show = isWithinInterval(now, {
                start: startDateTime,
                end: endDateTime,
              });
            }
          }

          if (scheduleType == 1) {
            if (startTime < endTime) {
              for (
                let i = 0;
                i < item.schedule.selectedWeekDays.length && !show;
                i++
              ) {
                if (
                  item.schedule.selectedWeekDays[i] == now.getDay() &&
                  now.getHours() >= startTime &&
                  now.getHours() < endTime
                ) {
                  show = true;
                }
              }
            } else {
              for (
                let i = 0;
                i < item.schedule.selectedWeekDays.length && !show;
                i++
              ) {
                if (
                  (item.schedule.selectedWeekDays[i] == now.getDay() &&
                    now.getHours() >= startTime &&
                    now.getHours() < 24) ||
                  ((item.schedule.selectedWeekDays[i] + 1) % 7 ==
                    now.getDay() &&
                    now.getHours() >= 0 &&
                    now.getHours() < endTime)
                ) {
                  show = true;
                }
              }
            }
          }

          return show;
        }
      });
    },
  },
};
</script>
